<template>
    <div>
        <div
            class="bg-cover"
            style="background-image: url(/images/banner-bg.jpg)">
            <div class="container py-12">
                <h1 class="text-4xl uppercase font-light">{{ author.name }}</h1>
            </div>
        </div>

        <div class="container mb-12">

            <Breadcrumbs :breadcrumbs="[
                {label: 'Home', href: '/'},
                {label: 'Authors', href: '/author-directory'},
                {label: author.name, href: null}
            ]" class="mb-4 pt-4 pb-2"/>

            <div class="row mb-6">
                <div class="text-sm mb-6 md:mb-0 col-full md:col-1/3 lg:col-1/4">
                    <div :class="{'flex justify-center items-center bg-gray-300 h-64': !author.portrait}"
                         class="w-64 max-w-full text-center">
                        <img v-if="author.portrait" :alt="author.name" :src="`/media/${author.portrait.uuid}`">
                        <font-awesome-icon v-else icon="user-md" size="5x"/>
                    </div>
                </div>
                <div class="text-sm col-full md:col-2/3 lg:col-3/4 space-y-4">
                    <p>{{ author.name }}<span v-if="author.medical_title">, {{ author.medical_title }}</span> <a v-if="author.orcid_id" :href="`https://orcid.org/${author.orcid_id}`" target="_blank"  class="orcid_id"><img alt="iD" src="/images/orcid_image.png" class="d-none d-md-block ico"></a></p>
                    <p v-if="author.job_title" class="author.job_title ">{{ author.job_title }}</p>
                    <p v-if="author.institution">{{ author.institution }}</p>
                    <div v-if="author.biography" class="prose prose-sm" v-html="author.biography"></div>
                </div>
            </div>

            <h2 class="text-3xl mb-4">Contributions:</h2>
            <PostsList :posts="author.posts"/>
        </div>
    </div>
</template>

<script>
import HasMetaData from "@app/Shared/Mixins/HasMetaData";
import Layout from "@app/Shared/Components/Layout";
import Breadcrumbs from "@app/Shared/Components/Breadcrumbs";
import PostsList from "@app/Shared/Components/PostsList";

export default {

    mixins: [HasMetaData],

    props: {
        author: Object,
    },

    layout: Layout,

    components: {
        Breadcrumbs,
        PostsList
    },
};
</script>

